const _log = console.log;
const ENGINE_EVENTS = {
  INIT: "init",
  MOVE: "move",
};

export default class GameEval {
  // Private props
  #engineWorker = null;
  #score = 0;
  #mateValue = null; // Store original mate value for display
  #rawEvaluation = null; // Store raw evaluation for accuracy calculation
  #event = "";
  #isBlackTurn = false; // Track whose turn it is

  #movesHistory = [];
  // Public props
  depth = 12; // default depth is 12

  onReady = null;
  onMoveComplete = null;

  constructor() {
    console.log("Game Eval constructed");
    this.init();
  }

  setDepth(depth) {
    this.depth = depth;
  }

  init() {
    this.loadEngine();

    this.#event = ENGINE_EVENTS.INIT;

    // start UCI
    this.send("uci");
    // start new game
    this.send("ucinewgame");
    // set new game position
    this.send("position startpos");
    // start search
    this.send("go depth " + this.depth);
  }

  engineOnMessage(e) {
    let response = e.data;

    // _log(`WORKER: (${this.#event})`, response);

    let matches = response.match(
      /depth (\d+) .*score (cp|mate) ([-\d]+) .*pv (.+)/
    );
    if (matches) {
      const scoreType = matches[2];
      let scoreValue = parseInt(matches[3]);
      
      // The evaluation is from the perspective of the side to move.
      // We need to normalize it to always be from White's perspective.
      if (this.#isBlackTurn) {
        console.log("Black's turn, inverting score. scoreValue:", scoreValue);
        scoreValue = -scoreValue;
      }
      
      if (scoreType === "mate") {
        // Mate positions: store mate value for display and formatted string for accuracy calculation
        this.#mateValue = scoreValue; // Used by display logic to show "#3"
        this.#rawEvaluation = `#${scoreValue}`; // Used by accuracy calculation ("#3" format)
        // Note: #score is unused for mate positions (display uses mateValue instead)
      } else {
        // Regular centipawn scores: store numeric value for both display and accuracy
        this.#mateValue = null;
        this.#rawEvaluation = scoreValue; // Used by accuracy calculation (numeric format)
        this.#score = scoreValue; // Used by display logic (converted to pawn units)
      }
    }

    /// Try to determine if the stream is done.
    if (
      response.startsWith("bestmove") ||
      response.startsWith("Unknown command")
    ) {
      _log("COMPLETE!!!", this.#event);
      if (this.#event === ENGINE_EVENTS.INIT) {
        this.#event = null;
        if (this.onReady) this.onReady();
      } else if (this.#event === ENGINE_EVENTS.MOVE) {
        this.#event = null;
        if (this.onMoveComplete)
          this.onMoveComplete({
            number: this.#movesHistory.length,
            move: this.#movesHistory[this.#movesHistory.length - 1],
            score: this.#score,
            mateValue: this.#mateValue,
            rawEvaluation: this.#rawEvaluation,
          });
      }
    }
  }

  send(cmd) {
    this.#engineWorker.postMessage(cmd);
  }

  sendMove(move) {
    this.#event = ENGINE_EVENTS.MOVE;
    this.#movesHistory.push(move);
    
    // Determine whose turn it is (even moves = White's turn, odd moves = Black's turn)
    this.#isBlackTurn = this.#movesHistory.length % 2 === 1;

    this.send("position startpos moves " + this.#movesHistory.join(" "));
    this.send("go depth " + this.depth);
  }

  loadEngine() {
    this.#engineWorker = new Worker("js/stockfish6.js");
    this.#engineWorker.onmessage = this.engineOnMessage.bind(this);
  }
}
